interface AuthData {
  accessToken: string | null
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthData => ({
    accessToken: null, // The legacy access token
  }),
  actions: {
    storeToken(token: string) {
      this.accessToken = token
    },
    getStoredToken() {
      if (!this.accessToken) {
        // We may still be logged in in another tab
        const { $auth } = useNuxtApp()
        $auth.surveySession()
        return null
      }

      return this.accessToken
    },
    async refreshToken() {
      const { apisix } = useRuntimeConfig().public

      try {
        // APISIX does not allow a GET
        const { user } = await $fetch<{ user: { username: string; token: string } }>(`${apisix.url}/phoebe/v1/token`, {
          method: 'POST',
          credentials: 'include',
          body: {},
        })

        this.accessToken = user.token
      } catch {
        this.accessToken = null
      }
    },
    async refreshPermissions() {
      const { $api } = useNuxtApp()
      const { logError } = useErrorHandling()

      try {
        await $api('/auth/refresh-token', { method: 'POST' })
        // The legacy token is a copy of the gateway's, so it needs re-copying too
        await this.refreshToken()
      } catch (error) {
        logError('Failed to refresh the permissions in the access token', error)
      }
    },
    removeStoredToken() {
      this.$reset()
    },
  },
})
